import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CompleteSignup = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "complete-signup" */ './hocs')),
});
